import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  DirectusCongressionalDistrictsResult,
  DirectusReportFields,
  DirectusReportPayload,
  DirectusReportResult,
  DirectusReportTypesResult,
} from '@interfaces';
import { map, Observable, shareReplay } from 'rxjs';
import { EnvService } from './env.service';

@Injectable({
  providedIn: 'root',
})
export class ReportsService {
  public apiUrl = '';
  private readonly options = {};
  private congressionalDistricts$: Observable<DirectusCongressionalDistrictsResult> | null = null;

  constructor(protected httpClient: HttpClient, protected env: EnvService) {
    this.apiUrl = this.env.environment.directus_url;
    this.options = {
      responseType: 'json',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };
  }

  getResourceUrl(): string {
    return 'reports';
  }

  getDirectusReportFields(): Observable<DirectusReportFields> {
    const url = `${this.apiUrl}fields/${this.getResourceUrl()}`;

    return this.httpClient
      .get(url, this.options)
      .pipe(map((json: any) => json as DirectusReportFields));
  }

  getDirectusReportTypes(): Observable<DirectusReportTypesResult> {
    const url = `${this.apiUrl}items/report_types`;

    return this.httpClient
      .get(url, this.options)
      .pipe(map((json: any) => json as DirectusReportTypesResult));
  }

  getCongressionalDistricts(): Observable<DirectusCongressionalDistrictsResult> {
    if (!this.congressionalDistricts$) {
      // Fetch all congressional districts
      const url = `${this.apiUrl}items/congressional_districts?limit=-1`;

      this.congressionalDistricts$ = this.httpClient.get(url, this.options).pipe(
        map((json: any) => json as DirectusCongressionalDistrictsResult),
        shareReplay(1),
      );
    }

    return this.congressionalDistricts$;
  }

  createReport(
    data: DirectusReportPayload | { [key: string]: any },
  ): Observable<DirectusReportResult> {
    const url = `${this.apiUrl}items/${this.getResourceUrl()}`;

    return this.httpClient
      .post(url, data, this.options)
      .pipe(map((json: any) => json as DirectusReportResult));
  }
}
